export const skillLevels = [
    { level: 'basic', name: 'Básico' },
    { level: 'intermediate', name: 'Intermedio' },
    { level: 'expert', name: 'Avanzado' }
];
